import React from "react";
import "./Rating.scss";

type Props = {
    index: number;
    question: string;
    rating?: number;
    setRating: (rating?: number) => void;
};

const Rating: React.FC<Props> = ({ rating, setRating, question, index }) => {
    const ratings: React.DetailedHTMLProps<
        React.LiHTMLAttributes<HTMLLIElement>,
        HTMLLIElement
    >[] = [];

    const handleOnchange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setRating(parseInt(e.target.value));
    };

    const getLabelClass = (index: number) => {
        if (index <= 5) return "red_label";
        else if (index <= 8) return "yellow_label";
        else return "green_lable";
    };

    for (let i = 0; i <= 10; i++) {
        ratings.push(
            <li key={i}>
                <input
                    type="radio"
                    value={`${i}`}
                    id={`radio${index}${i}`}
                    name={`radio${index}`}
                    checked={rating === i}
                    onChange={(e) => handleOnchange(e)}
                />
                <label
                    className={getLabelClass(i)}
                    htmlFor={`radio${index}${i}`}
                >
                    {i}
                </label>
            </li>
        );
    }

    return (
        <div className="feedback__rating">
            <div className="rating__question">
                <p>{question}</p>
                <button onClick={() => setRating(undefined)}>Reset</button>
            </div>
            <ul>{ratings}</ul>
        </div>
    );
};

export default Rating;
